import classNames from "classnames";
import Image from 'next/image';
import Link from "next/link";
import React, { FC } from "react";
import { createImageSizes } from '../../utils/image';

export enum ListItemLayout {
  left,
  right,
  top,
  bottom,
}

type ListItemProps = {
  src?: string;
  text: string;
  alt?: string;
  imageStyle?: string | string[];
  textStyle?: string | string[];
  layout?: ListItemLayout;
  link?: string;
  breakWord?: boolean;
};

const ListItem: FC<ListItemProps> = ({
  src,
  text,
  alt,
  imageStyle,
  textStyle,
  layout = ListItemLayout["left"],
  link,
  breakWord = false,
}) => {
  const layoutStyleMap: any = {
    left: "flex-row",
    right: "flex-row-reverse",
    top: "flex-col",
    bottom: "flex-col-reverse",
  };

  const layoutStyle = layoutStyleMap[ListItemLayout[layout]] ?? "";

  const wrap = (children: React.ReactElement) =>
    link ? (
      <Link href={link} passHref>
        <a>{children}</a>
      </Link>
    ) : (
      <>{children}</>
    );

  return wrap(
    <div
      className={classNames(
        "flex",
        "items-center",
        { "hover:cursor-pointer": link },
        { "hover:underline": link },
        layoutStyle
      )}
    >
      {src && (
        <div className={classNames("relative", imageStyle)}>
          <Image layout="fill" src={src} alt={alt} className="object-cover" sizes={createImageSizes({
              mobile: '15vw',
              tablet: '15vw',
              desktop: '15vw'
            })} />
        </div>
      )}
      <span
        style={{ wordBreak: breakWord ? "break-word" : "initial" }}
        className={classNames(
          { "ml-2": src && layout === ListItemLayout.left },
          { "mr-2": src && layout === ListItemLayout.right },
          textStyle
        )}
      >
        {text}
      </span>
    </div>
  );
};

export default ListItem;
